import moment from 'moment'

moment.locale('fr')

export function useFormatPeriod(period, periodicity = 'monthly') {

    if ( !period ) return ""
    
    let month = parseInt(moment(period.startAt).format('M'))
    let quarter
    switch ( periodicity ) {

        case 'monthly' :
            var libelle = moment(period.startAt).format('MMM')
            return ( libelle.charAt(0).toUpperCase() + libelle.slice(1) )

        case 'quarterly' :
            if ( month < 4 ) {
                quarter = 'T1'
            }
            else if ( month > 3 && month < 7 ) {
                quarter = 'T2'
            }
            else if ( month > 6 && month < 10 ) {
                quarter = 'T3'
            }
            else if ( month > 9 ) {
                quarter = 'T4'
            }   
            return moment(period.startAt).format('YY') + quarter

        case 'yearly' :
            return moment(period.startAt).format('YYYY')  
    }
}